import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';
import { getDatePickerMode } from '../common/components';
import {
  FormCheckbox,
  FormDateRangePicker,
  FormField,
  FormSelect,
} from '../common/form';
import { useSystemClassifierSelectOptions } from '../configuration';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import type { Frequency } from '../dataobject';
import translations from './TimeSeriesFilters.translations.json';

const { addTranslations, t } = i18nNsFactory(
  'visual-validation-time-series-filters',
);
addTranslations(translations);

export const TimeSeriesFilters = ({
  disabled = false,
  frequency,
  isComparisonView = false,
  isTimeSeriesView = false,
}: {
  disabled?: boolean;
  frequency?: Frequency;
  isComparisonView?: boolean;
  isTimeSeriesView?: boolean;
}) => {
  const { setValue } = useFormContext();
  const {
    TIME_SERIES_VERSION: timeSeriesVersionOptions,
    TIME_SERIES_COMPARISON_VERSION: timeSeriesComparisonVersionOptions,
  } = useSystemClassifierSelectOptions(
    ['TIME_SERIES_VERSION', 'TIME_SERIES_COMPARISON_VERSION'],
    'code',
  );

  return (
    <>
      <StyledFormField
        name="valueDateRange"
        label={t('fields.valueDateRange.label')}
        required
      >
        <FormDateRangePicker
          name="valueDateRange"
          allowEmpty={[false, false]}
          picker={getDatePickerMode(frequency)}
          endOfPeriod
          disabled={disabled}
        />
      </StyledFormField>
      <StyledFormField
        name="versionRule"
        label={t(`fields.versionRule${isComparisonView ? '1' : ''}.label`)}
        size="small"
        required
      >
        <FormSelect
          name="versionRule"
          placeholder={t(
            `fields.versionRule${isComparisonView ? '1' : ''}.placeholder`,
          )}
          styles={{
            popup: { root: { width: 'max-content' } },
          }}
          options={
            isComparisonView
              ? timeSeriesComparisonVersionOptions
              : timeSeriesVersionOptions
          }
          disabled={disabled}
        />
      </StyledFormField>
      {isComparisonView && (
        <StyledFormField
          name="versionRule2"
          label={t('fields.versionRule2.label')}
          size="small"
          required
        >
          <FormSelect
            name="versionRule2"
            placeholder={t('fields.versionRule2.placeholder')}
            styles={{
              popup: { root: { width: 'max-content' } },
            }}
            options={timeSeriesComparisonVersionOptions}
            disabled={disabled}
          />
        </StyledFormField>
      )}
      {isTimeSeriesView && (
        <CheckboxContainer>
          <FormCheckbox
            name="outliers"
            disabled={disabled}
            onChange={({ target }) => {
              if (target.checked) {
                setValue('hodricPrescotti', false, { shouldDirty: true });
              }
            }}
          >
            {t('fields.outliers.label')}
          </FormCheckbox>
          <FormCheckbox
            name="hodricPrescotti"
            disabled={disabled}
            onChange={({ target }) => {
              if (target.checked) {
                setValue('outliers', false, { shouldDirty: true });
              }
            }}
          >
            {t('fields.hp.label')}
          </FormCheckbox>
        </CheckboxContainer>
      )}
    </>
  );
};

const StyledFormField = styled(FormField)`
  width: 216px;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
  margin-top: 34px;
`;
